import  { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import Toolbar from "@mui/material/Toolbar";

import CustomDrawer from "../components/CustomDrawer";
import BoxGroup from "../components/BoxGroup";

import WorkbookDisplay from "../components/WorkbookDisplay";
import LineChartDisplay from "../components/LineChartDisplay";
import PieChartDisplay from "../components/PieChartDisplay";
import RadarChartDisplay from "../components/RadarChartDisplay";

import { useLocation } from "react-router-dom";



import Layout from "../components/layout/Layout";

const FInnanceDashboard = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);


  const location = useLocation();
  const { name } = location.state || {}; 

  




  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return (
    <Layout>
      <div>
        {name && <h1 className="ms-5">{name}</h1>}
        <main>
          <div>
            <BoxGroup
              isDrawerOpen={isDrawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />
           
            <CustomDrawer
              isDrawerOpen={isDrawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                width: "100%",
                paddingTop: "64px",
                paddingRight: `${isDrawerOpen ? "20%" : "0px"}`,
              }}
            >
              <Toolbar />
              <Box component="section" mt={4}>
                <Container>
                  <Grid
                    container
                    spacing={4}
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <Grid item xs={12} md={6} style={{ display: "flex" }}>
                      <Paper
                        sx={{ padding: 4, backgroundColor: "#e0e0e0", flex: 1 }}
                        elevation={3}
                      >
                        <WorkbookDisplay />
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: "flex" }}>
                      <Paper
                        sx={{ padding: 4, backgroundColor: "#d0d0d0", flex: 1 }}
                        elevation={3}
                      >
                        <LineChartDisplay />
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: "flex" }}>
                      <Paper
                        sx={{ padding: 4, backgroundColor: "#c0c0c0", flex: 1 }}
                        elevation={3}
                      >
                        <PieChartDisplay />
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: "flex" }}>
                      <Paper
                        sx={{ padding: 4, backgroundColor: "#b0b0b0", flex: 1 }}
                        elevation={3}
                      >
                        <RadarChartDisplay />
                      </Paper>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            </Box>
          </div>
        </main>
       
      </div>
      
    </Layout>
  );
};

export default FInnanceDashboard;
